import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import { Error } from "@/helpers";
import {Index} from "@/pages/index";
import CasesRealTime from "@/pages/CasesRealTime";
import CasesConteudoSocial from "@/pages/CasesConteudoSocial";
import CasesTransmissaoAoVivo from "@/pages/CasesTransmissaoAoVivo";
import CasesJogarJunto from "@/pages/CasesJogarJunto";
import CasesCampanhas from "@/pages/CasesCampanhas";

const Routes = () => {

  return (
    <BrowserRouter>
      <Switch>
        <Route exact path="/" component={Index} />
        <Route exact path="/CasesRealTime" component={CasesRealTime} />
		<Route exact path="/CasesConteudoSocial" component={CasesConteudoSocial} />
		<Route exact path="/CasesJogarJunto" component={CasesJogarJunto} />
		<Route exact path="/CasesTransmissaoAoVivo" component={CasesTransmissaoAoVivo} />
		<Route exact path="/CasesCampanhas" component={CasesCampanhas} />
        <Route path="*" component={Error} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
